<template>
  <div class="veo-values-block position-relative">
    <lazy-image
      :src="image_src"
      :lazy_src="image_lazy_src"
      cover_img
      class="veo-values-block__bg"/>
    <div class="container veo-values-block__container position-relative">
      <default-title
        white
        class="text-center veo-values-block__container-title"
        :title="title"
        title_tag="h3"
      />
      <div class="veo-values-block__circle">
        <default-title
          white
          class="veo-values-block__circle-title text-center"
          :title="get_center_title"
          title_tag="h4"
        />
        <veo-values-item
          v-for="(item, key) in values"
          :icon_src="item.icon"
          :image_src="item.img"
          :image_lazy_src="item.img_lazy"
          :title="item.title"
          :text="item.text"
          :class="`circle-item_order-${item.mobile_order_class}`"
          class="veo-values-block__circle-item"
          :key="`values-item-${uid}-${key}`"/>
      </div>
    </div>
  </div>
</template>

<script>

import LazyImage from "../small_parts/LazyImage.vue";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import VeoValuesItem from "../parts/builder/VeoValuesItem.vue";

export default {
  name: "VeoValuesBlock",
  components: {VeoValuesItem, DefaultTitle, LazyImage},
  props: {
    /**props**/
    image_src: {
      type: String,
      required: true,
      admin_type: 'image',
    },
    image_lazy_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    center_title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    circle_title_1: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    circle_text_1: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    circle_title_2: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    circle_text_2: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    circle_title_3: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    circle_text_3: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    circle_title_4: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    circle_text_4: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    circle_title_5: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    circle_text_5: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    /**props**/
  },
  computed: {
    uid() {
      return this._uid
    },
    get_center_title() {
      return this.center_title ? this.center_title : this.$t('text.no_waste_just_value')
    },
    values() {
      return [
        {
          title: this.circle_title_1,
          text: this.circle_text_1,
          icon: '/images/icons/veo_values_1.svg',
          img: '/images/page_data/veo_values_1.jpg',
          img_lazy: '/images/page_data/veo_values_1-thumb.jpg',
          mobile_order_class: 1,
        },
        {
          title: this.circle_title_2,
          text: this.circle_text_2,
          icon: '/images/icons/veo_values_5.svg',
          img: '/images/page_data/veo_values_2.jpg',
          img_lazy: '/images/page_data/veo_values_2-thumb.jpg',
          mobile_order_class: 2,
        },
        {
          title: this.circle_title_3,
          text: this.circle_text_3,
          icon: '/images/icons/veo_values_2.svg',
          img: '/images/page_data/veo_values_3.jpg',
          img_lazy: '/images/page_data/veo_values_3-thumb.jpg',
          mobile_order_class: 3,
        },
        {
          title: this.circle_title_4,
          text: this.circle_text_4,
          icon: '/images/icons/veo_values_4.svg',
          img: '/images/page_data/veo_values_5.jpg',
          img_lazy: '/images/page_data/veo_values_5-thumb.jpg',
          mobile_order_class: 5,
        },
        {
          title: this.circle_title_5,
          text: this.circle_text_5,
          icon: '/images/icons/veo_values_3.svg',
          img: '/images/page_data/veo_values_4.jpg',
          img_lazy: '/images/page_data/veo_values_4-thumb.jpg',
          mobile_order_class: 4,
        },
      ]
    },
  }
}
</script>
